import React from 'react'

import donationTier from './donationTier'

const TieredDonation = ({ order, config }) =>
  <div className="overlay p-2 rounded-3">
    <div className="h6 mb-0">
      <span className="d-block text-nowrap">
        {config.show_full_name ? order.donor_name : order.donor_name_and_initial} <br/> {donationTier(order)}
      </span>
    </div>
  </div>

export default TieredDonation
